import React, {FC, memo} from 'react';

import styled from 'styled-components';
import { NewsItem } from '../../../../models/newsItem';
import colors from '../../../../config/colors';
import H3 from '../../../Headings/H3';
import parse from 'html-react-parser';
import P from '../../../Paragraph';
import { generatePath, Link } from 'react-router-dom';
import routes from '../../../../config/routes';

interface IMostReadNews {
    item: NewsItem;
}

const MostReadNews: FC<IMostReadNews> = ({item}) => {

    return (
        <MostReadNewsWrapper key={item.unique_id}>
            <MostReadNewsLink to={generatePath(routes.NewsDetailPage, {'urlSlug' : item.slug, 'id': item.unique_id})}>
                <NumberOfViews><svg><use xlinkHref={`#view`} /></svg> <span>{item.visited*3}</span></NumberOfViews>
                <H3>{item.title}</H3>
                <Description>{parse(`${item.body}`)}</Description>
            </MostReadNewsLink>  
        </MostReadNewsWrapper>    
    )
}

const MostReadNewsWrapper = styled.div`
    background: ${colors.WHITE};
    padding: 15px 20px;
    margin: 20px 0;
    position: relative;
    h3 {
        font-size: 20px;
    }
    p {
        margin-bottom: 10px;
    }
    &:hover {
        background: ${colors.PRIMARY_PURPLE};
        transition: all 100ms ease-in-out;
        h3, p, span {
            color: ${colors.WHITE};
        }
        svg {
            fill: ${colors.WHITE};
        }
    }
`;

const MostReadNewsLink = styled(Link)``;

const NumberOfViews = styled.span`
    font-size: 10px;
    color: ${colors.GRAY_MEDIUM};
    position: absolute;
    top: 6px;
    right: 13px;
    display: flex;
    align-items: center;
    svg {
        fill: ${colors.GRAY_MEDIUM};
        margin-right: 5px;
    }
`;

const Description = styled(P)`
    overflow: hidden;
    text-overflow: ellipsis;
`;


export default memo(MostReadNews);